document.getElementById('search-mobile-input').addEventListener('input', function () {
  const query = this.value;
  if (query.length >= 3) {  // Solo hacer la búsqueda si la longitud es mayor o igual a 3 caracteres
    searchResults(query);
  } else {
    document.getElementById('search-results-mobile').style.display = 'none'; // Ocultar los resultados si la búsqueda es muy corta
  }
});

function searchResults(query) {
  fetch('/search/suggest.json?q=' + query)
    .then(response => response.json())
    .then(data => {
      const resultsContainer = document.getElementById('search-results-mobile');
      resultsContainer.innerHTML = "";  // Limpiar resultados previos
      if (data.products.length > 0) {
        data.products.forEach(product => {
          const resultItem = document.createElement('div');
          resultItem.classList.add('search-result-item');
          resultItem.innerHTML = `
            <img src="${product.featured_image ? product.featured_image.src : 'https://via.placeholder.com/150'}" alt="${product.title}" class="search-result-image" />
            <span class="search-result-title">${product.title}</span>
          `;
          resultItem.addEventListener('click', function () {
            window.location.href = product.url;
          });
          resultsContainer.appendChild(resultItem);
        });
        resultsContainer.style.display = 'block';  // Mostrar resultados
      } else {
        resultsContainer.innerHTML = "<p>No se encontraron resultados</p>";
        resultsContainer.style.display = 'block';
      }
    });
}

